import { site } from "../content";
import { Reveal, SectionHeading } from "./Reveal";

export default function Story() {
  return (
    <section id="historia" data-testid="story-section" className="relative py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <Reveal>
            <div className="relative mx-auto w-full max-w-md">
              <div className="absolute -inset-3 rounded-3xl border border-gold/20" aria-hidden="true" />
              <img
                src={site.assets.founder}
                alt={`${site.responsible}, responsável pelo Barber Steamer, ao lado do equipamento`}
                loading="lazy"
                data-testid="founder-image"
                className="relative aspect-[3/4] w-full rounded-2xl border border-white/10 object-cover shadow-[0_32px_80px_rgba(0,0,0,0.6)]"
              />
              <div
                className="animate-float-slow absolute -bottom-6 -right-4 flex h-28 w-28 items-center justify-center rounded-full border border-gold/50 bg-ink/90 text-center shadow-[0_0_50px_rgba(252,172,4,0.25)] backdrop-blur-md md:-right-8"
                data-testid="made-in-brazil-seal"
              >
                <span className="px-3 font-display text-[10px] font-black uppercase leading-relaxed tracking-[0.2em] text-gold">
                  Produzido no Brasil
                </span>
              </div>
            </div>
          </Reveal>

          <div>
            <SectionHeading
              chapter="11"
              eyebrow="Desde 2016"
              title="Desenvolvido para barbearias. Produzido no Brasil."
              testId="story-heading"
            />
            <Reveal delay={0.18}>
              <p className="mt-8 text-base leading-relaxed text-bone/65 md:text-lg" data-testid="story-text">
                {site.story}
              </p>
            </Reveal>
            <Reveal delay={0.26}>
              <blockquote className="mt-8 border-l-2 border-gold pl-6">
                <p className="font-serif text-xl italic leading-relaxed text-bone/80 md:text-2xl">
                  “{site.purpose}”
                </p>
                <cite className="mt-4 block font-display text-xs font-bold uppercase not-italic tracking-[0.25em] text-gold">
                  {site.responsible}
                </cite>
              </blockquote>
            </Reveal>
            <Reveal delay={0.34}>
              <ul className="mt-10 flex flex-wrap gap-3" data-testid="brand-pillars">
                {site.pillars.map((pillar) => (
                  <li
                    key={pillar}
                    className="rounded-full border border-white/15 bg-white/[0.04] px-6 py-3 font-display text-xs font-bold uppercase tracking-[0.3em] text-bone/80"
                  >
                    {pillar}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
